import { css } from '@emotion/core';
import styled from '@emotion/styled';

import theme from '@app/styles/theme';
import { rem } from '@app/styles/theme/layout';

const transition = css`
  transition: transform 200ms ease-out, opacity 200ms ease-out,
    box-shadow 200ms ease-out;
`;

const Radio = styled.input`
  &:checked,
  &:not(:checked) {
    position: absolute;
    left: -9999px;
  }

  &:checked + label,
  &:not(:checked) + label {
    position: relative;
    padding-left: ${rem(30)};
    cursor: pointer;
    display: inline-block;
    ${transition};
  }

  &:disabled + label::before,
  &:disabled + label::after {
    opacity: 0.6;
  }

  &:checked + label::before,
  &:not(:checked) + label::before {
    content: '';
    position: absolute;
    left: 0;
    top: 0;
    width: 18px;
    height: 18px;
    border: 1px solid ${theme.colors.labelGray};
    border-radius: 100%;
    background: #fff;
    ${transition};
  }

  &:checked + label::after,
  &:not(:checked) + label::after {
    content: '';
    width: 10px;
    height: 10px;
    background: ${theme.colors.darkGray};
    position: absolute;
    top: 5px;
    left: 5px;
    border-radius: 100%;
    ${transition};
  }

  &:not(:checked) + label::after {
    opacity: 0;
    transform: scale(0);
  }

  &:checked + label::after {
    opacity: 1;
    transform: scale(1);
  }

  &:checked label:hover::before,
  &:not(:checked) + label:hover::before {
    box-shadow: 0 1px 3px ${theme.colors.labelGray};
    ${transition};
  }

  &:focus:not(:checked) + label::before {
    border-color: ${theme.colors.darkGray};
    box-shadow: 0 1px 3px ${theme.colors.labelGray};
  }
`;

Radio.defaultProps = { type: 'radio' };

export default Radio;
